import React, { useContext } from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { UserContext } from "../../contexts/userContext";
import { useMutation } from "@apollo/client";
import { CHANGE_LANGUAGE } from "../../graphql/gqlUser";
import { T } from "../../components/T";

const LanguageToggle = () => {
  const { user } = useContext(UserContext);
  const [changeLanguageMutation] = useMutation(CHANGE_LANGUAGE);

  const onChangeLanguage = (language: string) => {
    changeLanguageMutation({ variables: { language } });
  };

  return (
    <FormControl sx={{ mt: 1, mb: 1, width: "100%" }}>
      <InputLabel color="secondary">
        <T str="Language" />
      </InputLabel>
      <Select
        fullWidth
        value={user.language}
        label={<T str="Language" />}
        onChange={(event) => onChangeLanguage(event.target.value)}
        color="secondary"
      >
        <MenuItem value={"en"}>English</MenuItem>

        <MenuItem value={"nl"}>Nederlands</MenuItem>
      </Select>
    </FormControl>
  );
};

export default LanguageToggle;
